import React from 'react';
import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeLockActionTypePayment} from './doppe-lock-action-type-payment';

export const doppeLockActionTypePaymentViewer = doppeActionTypeDefineViewerMetadata(doppeLockActionTypePayment, {

    loadViewerComponents: async () => {
        return {
            DoppeLockActionTypePaymentWidget: (await import('./doppe-lock-action-type-payment-widget/doppe-lock-action-type-payment-widget')).DoppeLockActionTypePaymentWidget
        };
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeLockActionTypePaymentWidget
        } = viewerComponents;

        return (
            <DoppeLockActionTypePaymentWidget
                {...renderProps}
            />
        );
    }
});
